var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcKey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11764_79419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.73 17.4C19.46 17.4 20.05 17.99 20.05 18.72C20.05 19.45 19.46 20.04 18.73 20.04C18 20.04 17.41 19.45 17.41 18.72C17.41 17.99 18 17.4 18.73 17.4Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.94 17.19C23.82 16.35 23.51 15.54 23.04 14.82C22.57 14.11 21.96 13.5 21.24 13.04C20.52 12.58 19.71 12.28 18.86 12.17C18.6 12.13 18.33 12.12 18.07 12.12C17.49 12.12 16.9 12.21 16.34 12.38L9.48 5.52H5.52V9.48L12.38 16.34C12.12 17.23 12.05 18.16 12.21 19.08C12.37 20 12.74 20.86 13.29 21.61C13.84 22.36 14.57 22.97 15.39 23.38C16.23 23.79 17.14 24.01 18.07 24.01C18.92 24.01 19.77 23.83 20.54 23.47C21.31 23.11 22.01 22.59 22.56 21.95C23.11 21.3 23.53 20.54 23.77 19.72C24.01 18.9 24.06 18.04 23.94 17.19ZM22.52 19.35C22.33 19.99 22.02 20.58 21.58 21.09C21.15 21.59 20.6 22 20 22.28C19.39 22.56 18.73 22.7 18.06 22.7C17.35 22.7 16.62 22.53 15.97 22.2C15.33 21.88 14.76 21.4 14.33 20.82C13.9 20.24 13.61 19.56 13.48 18.85C13.36 18.14 13.4 17.42 13.61 16.7L13.83 15.96L6.8 8.93V6.81H8.92L10.4 8.29L9.48 9.21L10.4 10.13L11.32 9.21L12.39 10.28L11.47 11.2L12.39 12.12L13.31 11.2L15.95 13.84L16.69 13.62C17.13 13.49 17.59 13.42 18.05 13.42C18.26 13.42 18.47 13.43 18.67 13.46C19.33 13.55 19.95 13.78 20.52 14.14C21.08 14.5 21.57 14.98 21.93 15.53C22.29 16.08 22.53 16.72 22.63 17.37C22.73 18.04 22.68 18.72 22.5 19.35H22.52Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 22.5H3C2.6 22.5 2.22 22.34 1.94 22.06C1.66 21.78 1.5 21.4 1.5 21V3C1.5 2.6 1.66 2.22 1.94 1.94C2.22 1.66 2.6 1.5 3 1.5H21C21.4 1.5 21.78 1.66 22.06 1.94C22.34 2.22 22.5 2.6 22.5 3V9H21V3H3V21H9V22.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11764_79419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcKey);
export default __webpack_public_path__ + "static/media/ic-key.3bca2baa3cc3ab86b9d1efb3bc5efa69.svg";
export { ForwardRef as ReactComponent };